import firebase from "firebase";

var firebaseConfig = {
    apiKey: "AIzaSyD376sbFoFOqNsWQxopWk6HOmCojjRsHUQ",
    authDomain: "disney-plus-jd.firebaseapp.com",
    projectId: "disney-plus-jd",
    storageBucket: "disney-plus-jd.appspot.com",
    messagingSenderId: "421070272065",
    appId: "1:421070272065:web:acc3a7920a1783c2ba38c0",
    measurementId: "G-LQX26XZ85W"
  };
  // Initialize Firebase
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  const storage = firebase.storage();

export { auth, provider, storage };
export default db;